import React, { memo } from "react";

export const OpenOptionList = memo(() => {

  return (
    <>
      <option value="0">不明</option>
      <option value="1">○</option>
      <option value="2">×</option>
      <option value="3">午前</option>
      <option value="4">午後</option>
      <option value="5">不定</option>
    </>
  );
});